/* cl-campaign-topline.js: the Black Friday marquee (sections/cl-campaign-topline).
 *
 * The track holds two identical groups and the CSS slides it by -50%, so the
 * loop is seamless as long as one group is wider than the line. The server
 * renders each group with the phrase set twice; this tops a group up when the
 * line is wider still and sets the duration so the speed is about 40px/s.
 *
 * Pause: the button toggles .is-paused (aria-pressed, the label swaps), and the
 * choice is kept for the session. Hover and focus pause in CSS.
 * Reduced motion: no track; one phrase shows at a time, cross-fading every 6 s
 * unless paused.
 */
(function () {
  var SPEED = 40;            // px per second
  var STILL_EVERY = 6000;    // ms per phrase with reduced motion
  var KEY = 'cl-topline-paused';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function store(v) { try { if (v) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function stored() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }

  function init(root) {
    if (!root || root.dataset.clTlReady === '1') return;
    root.dataset.clTlReady = '1';

    var btn = root.querySelector('[data-cl-tl-pause]');
    var track = root.querySelector('[data-cl-tl-track]');
    var viewport = root.querySelector('.cl-topline__viewport');
    var groups = track ? track.querySelectorAll('.cl-topline__group') : [];
    var set = root.querySelector('[data-cl-tl-set]');
    var still = root.querySelectorAll('.cl-topline__still-item');

    function fill() {
      if (!track || groups.length !== 2 || !set || !viewport) return;
      var need = viewport.getBoundingClientRect().width;
      var a = groups[0], b = groups[1];
      var guard = 0;
      while (a.getBoundingClientRect().width < need && guard < 12) {
        a.appendChild(set.cloneNode(true));
        b.appendChild(set.cloneNode(true));
        guard++;
      }
      var w = a.getBoundingClientRect().width;
      if (w > 0) root.style.setProperty('--cl-tl-dur', (w / SPEED).toFixed(2) + 's');
    }

    function setPaused(on) {
      root.classList.toggle('is-paused', on);
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var l = on ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause');
        if (l) btn.setAttribute('aria-label', l);
      }
    }

    if (btn) btn.addEventListener('click', function () {
      var on = !root.classList.contains('is-paused');
      setPaused(on);
      store(on);
    });
    setPaused(stored());

    // reduced motion: cross-fade one phrase at a time
    var idx = 0;
    setInterval(function () {
      if (!REDUCED.matches || still.length < 2) return;
      if (root.classList.contains('is-paused') || root.matches(':hover') || root.contains(document.activeElement)) return;
      still[idx].classList.remove('is-on');
      idx = (idx + 1) % still.length;
      still[idx].classList.add('is-on');
    }, STILL_EVERY);

    fill();
    if (window.ResizeObserver && viewport) new ResizeObserver(fill).observe(viewport);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fill);
  }

  function scan(scope) {
    var s = scope && scope.querySelectorAll ? scope : document;
    if (s.matches && s.matches('[data-cl-topline]')) init(s);
    Array.prototype.forEach.call(s.querySelectorAll('[data-cl-topline]'), init);
  }
  if (window.clToplineScan) { window.clToplineScan(document); return; }
  window.clToplineScan = scan;
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
